import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  petShopContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    color: theme.darkSlateGrayColor,
  },
  petShopTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '22rem',
    width: '100%',
    padding: '0 7rem',
    backgroundColor: theme.lighterSnowColor,
    fontFamily: theme.fontFamilyLexendDeca,
    fontSize: '1.5rem',
    fontWeight: 500,
  },
  petShopImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    color: theme.whiteColor,
    width: '17rem',
    height: '17rem',
    background:
      'url("https://i.picsum.photos/id/237/500/500.jpg?hmac=idOEkrJhLd7nEU5pNrAGCyJ6HHJdR_sit1qDt5J3Wo0") no-repeat center center',
    backgroundSize: 'cover',
  },
  petShopBody: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0 7rem',
    paddingRight: 0,
  },
  petShopLeftSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '20%',
    padding: '1rem 0',
    '& > a': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1.5rem 1rem',
      cursor: 'pointer',
      textDecoration: 'none',
      textTransform: 'uppercase',
      color: theme.darkSlateGrayColor,
      borderBottom: `2px solid ${theme.whiteSmokeColor}`,
    },
    '& > a:hover, & > a:hover::after': {
      color: theme.lightCoralColor,
    },
    '& > a::after': {
      content: '">"',
      color: theme.dimGrayColor,
      marginRight: '1rem',
    },
  },
  petShopRightSection: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '3rem',
    width: '80%',
    padding: '3rem 7rem 5rem 2rem',
    backgroundColor: theme.whiteSmokeColor,
  },
  petShopSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '2rem',
    padding: '2rem 3rem',
    borderRadius: '20px',
    backgroundColor: theme.whiteColor,
  },
  petShopSubContainerTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > span': {
      fontFamily: theme.fontFamilyArchivo,
      fontSize: '1.15rem',
      fontWeight: 500,
      textTransform: 'uppercase',
    },
    '& > a': {
      color: theme.lightCoralColor,
      fontFamily: theme.fontFamilyQuestrial,
    },
  },
  petShopSubContainerLinks: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '1rem',
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& > a': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      rowGap: '1rem',
      textTransform: 'uppercase',
      fontFamily: theme.fontFamilyLexendDeca,
      color: theme.darkSlateGrayColor,
    },
    '& > a:hover': {
      color: theme.lightCoralColor,
    },
    '& > a div': {
      height: '10rem',
      width: '10rem',
      background:
        'url("https://i.picsum.photos/id/312/500/500.jpg?hmac=ys8eh5ivAo4J0awMCxsFTTLa_VbjlbMbNztZmKkc_eg") no-repeat center center',
      backgroundSize: 'cover',
    },
  },
}));

export default useStyles;
